import union from 'lodash/union';
import without from 'lodash/without';

export function mergePreferences({ preferences, key, value, checked }) {
  const newPreferences = { ...preferences };

  newPreferences[key] = checked ? union(preferences[key], [value]) : without(preferences[key], value);
  return newPreferences;
}
